// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"3727b762","137":"a8f3aa79","143":"034d8622","196":"c09e803f","333":"a50c7100","629":"b751985d","724":"b477e5c1","892":"4a77093c","950":"78ccf31c"}[chunkId] + ".chunk.js";
};